export default __webpack_public_path__ + "static/media/moBounce2.b228a1dc.gif";